<template>
  <div>
    <div class="card-body" style="padding: 20px 0 20px 0;">
      <div class="row align-items-center">
        <div class="col-10">
          <h6>
            <b>NCM:</b>
            {{ dadosNCM.ncm }}
          </h6>
          <p>{{ dadosNCM.descricao }}</p>
        </div>
        <div class="col-md-2">
          <transition name="exibir">
            <button
              class="btn btn-info botao"
              type="button"
              @click="monitorar()"
              v-if="idmonitoramento == 0 && usuario != 0"
            >
              <span>Monitorar</span>
            </button>
            <button
              class="btn btn-info botao"
              type="button"
              disabled
              style="cursor: inherit"
              v-if="idmonitoramento == 0 && usuario == 0"
            >
              <span>Monitorar</span>
            </button>
          </transition>
          <button
            class="btn btn-info botao"
            type="button"
            v-b-modal="dadosNCM.ncm + 'confirmacao'"
            v-if="idmonitoramento != 0 && idmonitoramento != null"
          >
            <span>
              Desvincular
              <div
                class="spinner-border text-white loading ml-2"
                v-if="loadingMonitoramento"
                role="status"
              >
                <span class="sr-only">Aguarde...</span>
              </div>
            </span>
          </button>
        </div>
      </div>

      <hr class="hr" />

      <p style="margin-bottom:0px">
        <b>IPI:</b>
        {{ dadosNCM.ipi }}
      </p>
      <p style="margin-bottom:0px">
        <b>ICMS:</b>
        <a href="#" class="ml-1" v-b-modal="'aliquotasIcms'">Consultar</a>
      </p>
       <p style="margin-bottom:0px">
        <b>Reduções:</b>
        <a href="#" class="ml-1" v-b-modal="'aliquotasBenficios'">Consultar</a>
      </p>
       <p style="margin-bottom:0px">
        <b>Isenções:</b>
        <a href="#" class="ml-1" v-b-modal="'aliquotasIsencao'">Consultar</a>
      </p>
      <p style="margin-bottom:0px">
        <b>PIS/COFINS:</b>
        <br />
        <span v-html="dadosNCM.piscofins"></span>
      </p>

      <hr class="hr" />

      <!--Accordion wrapper-->
      <div
        class="accordion md-accordion mb-70"
        id="accordionEx"
        role="tablist"
        aria-multiselectable="true"
      >
        <div v-for="(item, index) in dadosNCM.ex" :key="index">
          <excecao :item="item" />
        </div>
      </div>
    </div>

    <!-- Modal Confirmação -->
    <b-modal
      :id="dadosNCM.ncm + 'confirmacao'"
      no-close-on-backdrop
      hide-header
      hide-footer
      centered
    >
      <div v-if="etapa == 0">
        <div class="iconeContent text-center m-auto">
          <i class="fas fa-exclamation danger"></i>
        </div>
        <h2 class="titulo">Confirmar desvinculação de NCM?</h2>
        <p class="lead text-muted alerta text-center">
          Ao desvincular uma NCM você deixará de receber as atualizações sobre ela.
          <br />Tem certeza?
          <i class="far fa-sad-tear"></i>
        </p>
        <div class="row text-center">
          <div class="col-6">
            <button
              class="cancel btn btn-lg btn-default"
              @click="$bvModal.hide(dadosNCM.ncm + 'confirmacao')"
            >Não, me mantenha atualizado!</button>
          </div>
          <div class="col-6">
            <button
              class="confirm btn btn-lg btn-danger"
              @click="confirmacao = true, desvincular()"
            >Sim, desvincular NCM!</button>
          </div>
        </div>
      </div>
      <div class="text-center m-auto" v-if="loadingMonitoramento && etapa == 2">
        <div class="spinner-border text-primary iconeLoading" role="status">
          <span class="sr-only">Aguarde...</span>
        </div>
      </div>

      <div v-if="etapa == 3" class="text-center">
        <p class="lead text-muted alerta fs-15">NCM desvinculada com Sucesso!</p>
        <i class="far fa-check-circle iconeSucesso text-success"></i>
        <div class="mt-4 text-right">
          <button class="btn btn-primary" @click="$bvModal.hide(dadosNCM.ncm + 'confirmacao')">OK</button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Confirmação FIM -->

    <!-- Modal -->
    <transition name="modaltransicao">
      <b-modal id="aliquotasIcms" title="Alíquotas do ICMS" size="lg">
        <div slot="default">
          <div class="alert alert-warning" role="alert">
            <span class="text-warning f-w">NOTA:</span> Para informações do Fundo de Combate a Pobreza
            <a
              class="ml-2"
              target="_blank"
              href="https://www.lefisc.com.br/boletins/2020/setembro_semana_4/fundo_amparo_pobreza/index.asp"
            >clique aqui</a>
          </div>

          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-6">Estado</th>
                <th class="col-md-6">NCM</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in dadosNCM.aliquotas" :key="index" class="w-100">
              <hr class="hr" />

              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-6">{{ aliquota.estado }}</td>
                    <td class="col-6">{{ aliquota.icms }}%</td>
                    <table class="table" v-if="aliquota.notas">
                      <td colspan="2" style="font-size:10px" class="w-100">
                        <b>Nota Lefisc:</b>
                        {{ aliquota.notas }}
                      </td>
                    </table>
                  </div>
                </div>
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('aliquotasIcms')"
          >Fechar</b-button>
        </div>
      </b-modal>
      <!-- Modal FIM -->
    </transition>
      <transition name="modaltransicao">
      <b-modal id="aliquotasIsencao" title="Isenções" size="lg">
        <div slot="default">   
          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-2">Estado</th>
                <th class="col-md-10">Nota</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in dadosNCM.isencao" :key="index" class="w-100">
              <hr class="hr" />
              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-2" v-html="aliquota.uf"></td>
                    <td class="col-10" v-if="aliquota.notas" v-html=" aliquota.notas"></td>
                    <td style="padding:0px; " class="col-10" v-else ><div class="vazio"> <span> {vazio}</span></div></td>
                  </div>
                </div>
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('aliquotasIsencao')"
          >Fechar</b-button>
        </div>
      </b-modal>
      <!-- Modal FIM -->
    </transition>
    <transition name="modaltransicao">
      <b-modal id="aliquotasBenficios" title="Reduções" size="lg">
        <div slot="default">   
          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-2">Estado</th>
                <th class="col-md-10">Nota</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in dadosNCM.beneficios" :key="index" class="w-100">
              <hr class="hr" />
              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-2" v-html="aliquota.uf"></td>
                    <td class="col-10" v-if="aliquota.notas" v-html="aliquota.notas"></td>
                    <td style="padding:0px; " class="col-10" v-else ><div class="vazio"> <span> {vazio}</span></div></td>
                  </div>
                </div>
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('aliquotasBenficios')"
          >Fechar</b-button>
        </div>
      </b-modal>
      <!-- Modal FIM -->
    </transition>
  </div>
</template>

<script>
import excecao from "./excecao";
import serviceMonitoramento from "../../services/ServiceMonitoramentoAlteracoes";
import serviceCookie from "../../services/ServiceCookie";
export default {
  props: ["dadosNCM"],
  components: {
    excecao
  },
  data() {
    return {
      loading: true,
      idmonitoramento: null,
      loadingMonitoramento: false,
      etapa: 0,
      usuario: ""
    };
  },
  methods: {
    monitorar() {
      this.$router.push({
        name: "Filtros",
        params: { ncm: this.dadosNCM.ncm }
      });
    },    
    async desvincular() {
      this.etapa = 1;
      if (this.confirmacao) {
        this.loadingMonitoramento = true;
        this.etapa = 2;
        await serviceMonitoramento
          .DeixarMonitoramento(this.idmonitoramento)
          .then(
            res => {
              this.loadingMonitoramento = false;
              if (res == "Você deixou de monitorar a NCM.") {
                this.idmonitoramento = 0;
                this.etapa = 3;
                this.$router.push({ name: "Minhas NCMs" });
              }
            },
            err => {
              console.error(err);
              this.loadingMonitoramento = false;
            }
          );
      }
    }
  },
  async created() {
    this.usuario = await serviceCookie.getCookie("idCliente");
    if (this.usuario.length > 0) {
      //this.usuario = this.usuario.substring(3);
      this.usuario = parseInt(this.usuario);
      if (!this.usuario) this.usuario = 0;
    }

    await serviceMonitoramento
      .estaMonitorando(this.dadosNCM.ncm, this.usuario)
      .then(
        res => {
          this.idmonitoramento = res;
        },
        err => {
          console.error(err);
        }
      );
  },  
};
</script>

<style scoped>
.hr {
  border-bottom: 1px solid #eceff8;
  border-top: 0 none;
  margin: 0px 0;
  padding: 0;
}

.modaltransicao-enter,
.modal-transicao-leave-to {
  opacity: 0;
}
.modaltransicao-enter-to,
.modaltransicao-leave {
  opacity: 1;
}
.modaltransicao-enter-active,
.modaltransicao-leave-active {
  transition: all 1s;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.exibir-enter,
.exibir-leave-to {
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  opacity: 1;
}
.exibir-enter-active,
.exibir-leave-active {
  transition: all 0.5s;
}

.iconeContent {
  height: 100px;
  width: 100px;
}

.danger {
  border: 3px solid #dc3545;
  border-radius: 100%;
  width: 100px;
  height: 100px;
  font-size: 60px;
  color: #dc3545;
  line-height: 100px;
}

.alerta {
  font-size: 12px;
  margin-top: 10px;
}

.titulo {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

.iconeLoading {
  font-size: 20px;
  width: 50px;
  height: 50px;
}
.vazio{
  height: 100%;
  background: #fff;
  max-width: 639px;
  display: flex;
  align-items: center;
  padding-left:10px;
}

.fs-15 {
  font-size: 15px;
}

@keyframes sucesso {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.iconeSucesso {
  font-size: 50px;
  animation-name: sucesso;
  animation-delay: 0.3s;
  animation-duration: 0.7s;
  animation-fill-mode: both;
}

.linkfcp {
  color: black;
}
.f-w {
  font-weight: bold;
}
@media (max-width: 425px) {
  .botao {
    text-align: left;
    margin-bottom: 20px;
  }
}
</style>